import { toast } from "react-toastify";
import {adoptionContract, eggAssetTokenId, nodeUrl} from './Constants';

const wavesTransaction = require('@waves/waves-transactions')

export async function startPandaAdoption(adoptionAmount,bidderSeed) {
    const startPandaAdoptionTx = wavesTransaction.invokeScript({
        dApp: adoptionContract,
        fee: 900000,
        call: {
            function: "startPandaAdoption"
        },
        payment: [{
            assetId: eggAssetTokenId, //assset Id 
            amount: adoptionAmount
        }],
        chainId: 84
    }, bidderSeed);

    let result = false;
    try {
        let tx = await wavesTransaction.broadcast(startPandaAdoptionTx, nodeUrl);
        console.log('Adoption Started successfully: ' + tx.id);
        return tx;
    } catch (e) {
        toast.error(e.message);
    }
    return result;
}

export async function finishPandaAdoption(txId, bidderSeed) {
    const finishPandaAdoptionTx = wavesTransaction.invokeScript({
        dApp: adoptionContract,
        fee: 900000,
        call: {
            function: "finishPandaAdoption",
            args: [{ "type": "string", "value": txId }]
        },
        chainId: 84
    }, bidderSeed);

    let result = false;
    try {
        let tx = await wavesTransaction.broadcast(finishPandaAdoptionTx, nodeUrl);
        console.log('Adopted successfully: ' + tx);
        result = true;
    } catch (e) {
        toast.error(e.message);
    }
    return result;
}
